import { gql } from "@apollo/client";

export const CREATE_BROWSER_CALL_LINK = gql`
  mutation createBrowserCallLink(
    $inboxId: ID
    $mediaMode: String
    $expiresInMinutes: Int
  ) {
    createBrowserCallLink(
      inboxId: $inboxId
      mediaMode: $mediaMode
      expiresInMinutes: $expiresInMinutes
    ) {
      url
      messageTemplate
      call {
        id
        roomId
        status
        channel
        mediaMode
        customerName
        linkExpiresAt
      }
    }
  }
`;

export const CANCEL_BROWSER_CALL_LINK = gql`
  mutation cancelBrowserCallLink($roomId: String!) {
    cancelBrowserCallLink(roomId: $roomId) {
      id
      roomId
      status
    }
  }
`;

export const JOIN_BROWSER_CALL_AS_GUEST = gql`
  mutation joinBrowserCallAsGuest(
    $roomId: String!
    $sdpOffer: String!
    $guestName: String
  ) {
    joinBrowserCallAsGuest(
      roomId: $roomId
      sdpOffer: $sdpOffer
      guestName: $guestName
    ) {
      id
      roomId
      status
      customerName
    }
  }
`;

export const ACCEPT_BROWSER_CALL = gql`
  mutation acceptBrowserCall($roomId: String!, $sdpAnswer: String!) {
    acceptBrowserCall(roomId: $roomId, sdpAnswer: $sdpAnswer) {
      id
      roomId
      status
      startedAt
    }
  }
`;

export const REJECT_BROWSER_CALL = gql`
  mutation rejectBrowserCall($roomId: String!, $reason: String) {
    rejectBrowserCall(roomId: $roomId, reason: $reason) {
      id
      roomId
      status
    }
  }
`;

export const SEND_BROWSER_CALL_ICE_CANDIDATE = gql`
  mutation sendBrowserCallIceCandidate(
    $roomId: String!
    $candidate: String!
    $fromRole: String!
  ) {
    sendBrowserCallIceCandidate(
      roomId: $roomId
      candidate: $candidate
      fromRole: $fromRole
    )
  }
`;

export const END_BROWSER_CALL = gql`
  mutation endBrowserCall(
    $roomId: String!
    $reason: String
    $mediaConnected: Boolean
  ) {
    endBrowserCall(
      roomId: $roomId
      reason: $reason
      mediaConnected: $mediaConnected
    ) {
      id
      roomId
      status
      endedAt
      durationSeconds
    }
  }
`;

export const UPLOAD_BROWSER_CALL_RECORDING = gql`
  mutation uploadBrowserCallRecording($roomId: String!, $file: Upload!) {
    uploadBrowserCallRecording(roomId: $roomId, file: $file) {
      id
      roomId
      recordingUrl
    }
  }
`;

export const TRANSCRIBE_BROWSER_CALL_RECORDING = gql`
  mutation transcribeBrowserCallRecording($roomId: String!) {
    transcribeBrowserCallRecording(roomId: $roomId)
  }
`;

export const REPORT_BROWSER_CALL_GUEST_ISSUE = gql`
  mutation reportBrowserCallGuestIssue(
    $roomId: String!
    $code: String!
    $detail: String
  ) {
    reportBrowserCallGuestIssue(roomId: $roomId, code: $code, detail: $detail)
  }
`;
